import { Bot, Sparkles, Users, Wand2 } from "lucide-react"
import type { LucideIcon } from "lucide-react"

// Registry of marketing/feature showcase pages. The header "Features" dropdown
// and the public footer both render from this list, so adding a new showcase
// page is a one-line change here — drop in the route, label, blurb, and icon
// and it appears in both places. `to` values must match real routes in the
// generated route tree.
export type FeaturePage = {
  to: string
  label: string
  description: string
  icon: LucideIcon
}

export const featurePages: FeaturePage[] = [
  {
    to: `/ai-trip-planner`,
    label: `AI Trip Planner`,
    description: `Chic drafts ideas, your crew shapes the trip on a live map`,
    icon: Wand2,
  },
  {
    to: `/group-trip-planner`,
    label: `Group Trip Planner`,
    description: `One itinerary your whole crew edits live`,
    icon: Users,
  },
  {
    to: `/claude`,
    label: `Claude Connector`,
    description: `Plan trips by chatting with Claude`,
    icon: Bot,
  },
  {
    to: `/pro`,
    label: `Pro Features`,
    description: `ChicReview, PDF, calendar & AI exports`,
    icon: Sparkles,
  },
]
